/**
 * ANAPI event-clock pairing for in-app capture.
 *
 * ABR pings GET /events/:id/clock when the camera opens, then applies
 * clock_offset_ms at Record / shutter. AppM can skip the GET with
 * sync-clock="false" when capture time is irrelevant.
 */

export function computeClockOffsetMs(serverNow, t0, t2) {
  const serverNowMs = Date.parse(serverNow)
  if (!Number.isFinite(serverNowMs) || !Number.isFinite(t0) || !Number.isFinite(t2)) {
    return null
  }
  return Math.round(serverNowMs - (t0 + t2) / 2)
}

export function syncedRecordedAt(deviceNowMs, clockOffsetMs) {
  const offset = Number.isFinite(clockOffsetMs) ? clockOffsetMs : 0
  return new Date(deviceNowMs + offset).toISOString()
}

export async function measureEventClock(fetchServerNow) {
  const t0 = Date.now()
  const result = await fetchServerNow()
  const t2 = Date.now()
  const serverNow = typeof result === 'string' ? result : result?.serverNow
  return {
    serverNow,
    clockOffsetMs: computeClockOffsetMs(serverNow, t0, t2)
  }
}

export function captureStamp({ enabled, deviceNowMs, clockOffsetMs }) {
  if (!enabled) return {}
  const recordedAt = syncedRecordedAt(deviceNowMs, clockOffsetMs)
  if (!Number.isFinite(clockOffsetMs)) {
    return { recordedAt }
  }
  return { recordedAt, clockOffsetMs }
}

export function clockEventDetail(stamp = {}) {
  const detail = {}
  if (stamp.recordedAt) detail.recordedAt = stamp.recordedAt
  if (Number.isFinite(stamp.clockOffsetMs)) detail.clockOffsetMs = stamp.clockOffsetMs
  return detail
}

export function isSyncClockEnabled(element) {
  return element?.getAttribute?.('sync-clock') !== 'false'
}

export async function beginCameraClockSession({ enabled, fetchServerNow }) {
  if (!enabled || typeof fetchServerNow !== 'function') {
    return { clockOffsetMs: null, synced: false }
  }
  try {
    const { clockOffsetMs } = await measureEventClock(fetchServerNow)
    if (!Number.isFinite(clockOffsetMs)) {
      return { clockOffsetMs: null, synced: false }
    }
    return { clockOffsetMs, synced: true }
  } catch {
    return { clockOffsetMs: null, synced: false }
  }
}
